import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { TrAccordionModule } from '../tr-accordion/tr-accordion.module';
import { SvgIconModule } from '../svg-icon/svg-icon.module';

/**
 * Components related to NOTIFICATIONS MENU
 */
import { NotificationsMenuService } from './notifications-menu/notifications-menu.service';
import { NotificationsMenuComponent } from './notifications-menu/notifications-menu.component';
import { NotificationsMenuItem } from './notifications-menu--item/notifications-menu--item.component';

/**
 * Components related to NOTIFICATIONS QUEUE
 */
import { NotificationsQueueService } from './notifications-queue/notifications-queue.service';
import { NotificationsQueue } from './notifications-queue/notifications-queue.component';
import { NotificationsQueueItem } from './notifications-queue--item/notifications-queue--item.component';

/**
 *  Components Service and Directives for to used NOTIFICATIONS OVERLAY LIST
 */
import { NotificationsOverlayList } from './notifications-overlay-list/notifications-overlay-list.component';
import { NotificationsOverlayListItem } from './notifications-overlay-list--item/notifications-overlay-list--item.component';
import { NotificationsOverlayListDirective } from './notifications-overlay-list/notifications-overlay-list.directive';
import { BarRatingModule } from 'ngx-bar-rating';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TrInputsModule } from '../tr-forms-inputs/tr-forms-inputs.module';
import { TrSpinnerButtonDirectiveModule } from '../../directives/tr-spinner-button/tr-spinner-button.module';
import { DateISOStringPipeModule } from '../../pipes';

@NgModule({
    declarations: [
        NotificationsMenuComponent,
        NotificationsMenuItem,
        NotificationsQueue,
        NotificationsQueueItem,
        NotificationsOverlayListDirective,
        NotificationsOverlayList,
        NotificationsOverlayListItem,
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,
        TrAccordionModule,
        TrInputsModule,
        BarRatingModule,
        TrSpinnerButtonDirectiveModule,
        DateISOStringPipeModule,
        SvgIconModule,
    ],
    exports: [
        NotificationsMenuComponent,
        NotificationsQueue,
    ],
    providers: [
        NotificationsMenuService,
        NotificationsQueueService,
    ],
    entryComponents: [
        NotificationsOverlayList,
        NotificationsQueueItem,
    ],
})

export class NotificationsModule {
}
